import { Routes, Route } from "react-router-dom";
import Login from "./componment/Login/Login";
import Dashboard from "./componment/Dashboard";
import Outlet from "./componment/Outlet";
import UserManagement from "./componment/User-Management/UserManagement";
import ActionView from "./componment/User-Management/ActionView";
import Breadcrumb from "./componment/Breadcrumb";
import ProductDetails from "./componment/User-Management/ProductDetails";
import ListingsManagement from "./componment/Listings-Management/ListingsManagement";
import ProtectedRoute from "./componment/ProtectedRoute";
import Banners from "./componment/AddBanners/Banners";
import AdsManagement from "./componment/Ads/AdsManagement";

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Public route */}
        <Route path="/" element={<Login />} />

        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Outlet"
          element={
            <ProtectedRoute>
              <Outlet />
            </ProtectedRoute>
          }
        />
        <Route
          path="/usermanagement"
          element={
            <ProtectedRoute>
              <UserManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ActionView"
          element={
            <ProtectedRoute>
              <ActionView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Breadcrumb"
          element={
            <ProtectedRoute>
              <Breadcrumb />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ProductDetails"
          element={
            <ProtectedRoute>
              <ProductDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ListingsManagement"
          element={
            <ProtectedRoute>
              <ListingsManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Banners"
          element={
            <ProtectedRoute>
              <Banners />
            </ProtectedRoute>
          }
        />
         <Route
          path="/AdsManagement"
          element={
            <ProtectedRoute>
              <AdsManagement />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
